import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ElementRef, NgZone } from '@angular/core';
import { PluginViewShiftsComponent } from '../plugin-view-shifts/plugin-view-shifts.component';
import { AlertsService } from '../../../core/alerts.service';
import { LocalisationService } from '../../../core/localisation.service';
import { SettingsService } from '../../../settings.service';
import { EventsService } from '../../../core/event.service';
import { ExecutorsService } from '../../executors.service';
import { DomainService } from '../../../domain.service';
import { GridService } from '../../grid.service';
var PluginViewGeneratedComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PluginViewGeneratedComponent, _super);
    function PluginViewGeneratedComponent(alertsService, localisationService, changeDetector, eventsService, settingsService, executorsService, domainService, elementRef, ngZone, gridService) {
        return _super.call(this, alertsService, localisationService, changeDetector, eventsService, settingsService, executorsService, domainService, elementRef, ngZone, gridService) || this;
    }
    /**
     * Gets the include query parameter value.
     * @protected
     * @returns The include query parameter value.
     */
    PluginViewGeneratedComponent.prototype.getIncludeOfTasklist = function () {
        if (!this._selectedFunction) {
            return 'Services UNPLANNED PURPOSES[GENERATED]';
        }
        return 'Services UNPLANNED CONCERNS[' + this._selectedFunction['Oid'] + '] PURPOSES[GENERATED]';
    };
    return PluginViewGeneratedComponent;
}(PluginViewShiftsComponent));
export { PluginViewGeneratedComponent };
